module.exports = __webpack_public_path__ + "static/media/alerta_desempenho.66e5b649.png";